import { graphql } from 'react-relay';

import useLazyLoadQuery from '../../../hooks/useLazyLoadQuery';
import {
  AssignedTaskStatusTabList_assignedTaskStatusCountsQuery,
  TaskStatusEnum,
} from '../../../relay/__generated__/AssignedTaskStatusTabList_assignedTaskStatusCountsQuery.graphql';
import EnumPair from '../../core/EnumPair';
import HorizontalDivider from '../../core/HorizontalDivider';
import TabList, { TabListProps } from '../../core/TabList';
import Text from '../../core/Text';

const assignedTaskStatusCountsForAssignedTaskStatusTabList = graphql`
  query AssignedTaskStatusTabList_assignedTaskStatusCountsQuery {
    assignedTaskStatusCounts {
      count
      status
    }
  }
`;

type Props = {
  selectedId: string;
} & Omit<
  TabListProps<{ id: string | number; value?: TaskStatusEnum; counter?: number }>,
  'items' | 'renderItem' | 'selectedIndex'
>;

const AssignedTaskStatusTabList = ({ selectedId = 'all', onSelect, ...props }: Props) => {
  const [{ assignedTaskStatusCounts }, refresh] =
    useLazyLoadQuery<AssignedTaskStatusTabList_assignedTaskStatusCountsQuery>(
      assignedTaskStatusCountsForAssignedTaskStatusTabList,
      {},
    );
  const totalCount = assignedTaskStatusCounts.reduce((acc, { count }) => acc + count, 0);

  const tabItems: { id: string; value?: TaskStatusEnum; counter?: number }[] = [
    { id: 'all', value: undefined, counter: totalCount },
    ...(
      [
        'problem_typing',
        'problem_creation',
        'image_creation',
        'first_labeling',
        'second_labeling',
        'review',
        'error_report',
        'published',
        'deactivated',
      ] as TaskStatusEnum[]
    ).map((taskStatus) => ({
      id: taskStatus,
      value: taskStatus,
      counter: assignedTaskStatusCounts.find(({ status }) => status === taskStatus)?.count || 0,
    })),
  ];

  return (
    <>
      <TabList
        items={tabItems}
        renderItem={({ id, value, counter }) => (
          <Text sx={{ fontSize: 1, whiteSpace: 'nowrap' }}>
            {id === 'all' ? '전체' : <EnumPair typename={'TaskStatusEnum'}>{value || ''}</EnumPair>}({counter})
          </Text>
        )}
        selectedIndex={tabItems.findIndex(({ id }) => id === selectedId)}
        onSelect={(...args) => {
          onSelect?.(...args);
          refresh();
        }}
        {...props}
      />
      <HorizontalDivider />
    </>
  );
};

export default AssignedTaskStatusTabList;
